import React from "react";
import { SHOP_INFO } from "../constants/shopData";
import { Instagram, Facebook, Youtube, Music2 } from "lucide-react";

const ICONS = {
  Instagram,
  Facebook,
  YouTube: Youtube,
  TikTok: Music2,
};

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        {/* Logo block placeholder */}
        <div className="flex items-center gap-4 mb-10" data-testid="footer-logo-block">
          <div className="w-16 h-16 bg-[#FF1F1F] border-4 border-white inline-flex items-center justify-center">
            <span className="font-heading text-3xl text-white leading-none">R</span>
          </div>
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-white/60">
              Logo Placeholder
            </div>
            <div className="font-heading text-2xl uppercase">Rocket Card Shop</div>
          </div>
        </div>

        <h2
          data-testid="footer-cta-heading"
          className="font-heading uppercase text-6xl sm:text-7xl lg:text-8xl leading-[0.9]"
        >
          Let&apos;s <span className="text-[#FF1F1F]">trade.</span>
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-white/60 mb-3">
              Visit
            </div>
            <div className="font-heading text-2xl uppercase">{SHOP_INFO.city}</div>
            <div className="font-mono text-xs normal-case tracking-wide text-white/70 mt-2 leading-relaxed" data-testid="footer-address">
              {SHOP_INFO.address}
            </div>
            <div className="font-mono text-xs uppercase tracking-widest text-white/60 mt-2">
              Appointment only
            </div>
          </div>

          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-white/60 mb-3">
              Contact
            </div>
            <a
              href={`tel:${SHOP_INFO.phone.replace(/[^\d+]/g, "")}`}
              data-testid="footer-phone-link"
              className="block font-heading text-xl uppercase hover:text-[#FF1F1F] transition-colors"
            >
              {SHOP_INFO.phone}
            </a>
            <a
              href={`mailto:${SHOP_INFO.email}`}
              data-testid="footer-email-link"
              className="block font-heading text-lg sm:text-xl normal-case tracking-tight mt-1 break-all hover:text-[#FF1F1F] transition-colors"
            >
              {SHOP_INFO.email}
            </a>
          </div>

          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-white/60 mb-3">
              Follow
            </div>
            <div className="flex flex-wrap gap-3">
              {SHOP_INFO.socials.map((s) => {
                const Icon = ICONS[s.label] || Instagram;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="w-12 h-12 inline-flex items-center justify-center border-4 border-white hover:bg-[#FF1F1F] hover:border-[#FF1F1F] transition-colors"
                    aria-label={s.label}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mt-3">
              Tap an icon to open our page
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t-2 border-white/20 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="font-mono text-xs uppercase tracking-widest text-white/50">
            © {new Date().getFullYear()} Rocket Card Shop · All rights reserved
          </div>
          <button
            data-testid="footer-cta-book"
            onClick={() => scrollToId("contact")}
            className="nb-btn-primary !text-base !px-5 !py-2.5"
          >
            Book An Appointment
          </button>
        </div>
      </div>
    </footer>
  );
}
